<template>
  <div v-if="loading.Data" class="d-flex flex-column h-100">
    <spinner-loading></spinner-loading>
  </div>
  <div v-else class="d-flex flex-column h-100">
    <div class="content-header-card chart header-position">
      <div class="content-header-name d-flex justify-content-between w-100">
        <div>{{ renderData.card_name }}</div>
        <div>
          <img
            v-if="renderData.tooltip"
            :src="Tooltip"
            class="tooltip-img"
            v-b-tooltip.hover.bottomleft.html
            :title="renderData.tooltip"
          />
        </div>
      </div>
    </div>
    <div v-if="renderData.data.length > 0" class="content-body-card">
      <b-row style="height: 65%">
        <b-col>
          <v-chart
            ref="chartBar"
            class="chart-customer"
            :option="option"
            autoresize
          />
        </b-col>
      </b-row>
      <b-row class="d-flex justify-content-evenly">
        <div v-for="item in renderData.data" :key="item.title">
          <b-col>
            <div>
              <b-row>
                <b-col>
                  <div class="d-flex align-items-center">
                    <div
                      class="pie-chart-radius-color"
                      :style="{ backgroundColor: item.color }"
                    />
                    <div class="pie-chart-title">
                      {{ item.title }}
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
            <div class="pie-chart-value">
              {{ formatter.format(item.value) }}
            </div>
            <div class="summary-dashboard-unit">
              {{ item.unit }}
            </div>
          </b-col>
        </div>
      </b-row>
    </div>
    <div v-else class="content-body-card h-100">
      <card-no-item :textNoImg="'Item Not Found'" :height="100" />
    </div>
  </div>
</template>

<script>
import store from "@/store";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart } from "echarts/charts";
import { TooltipComponent } from "echarts/components";
import { TitleComponent } from "echarts/components";
import Tooltip from "@/assets/images/icons/Tooltip.png";

import VChart from "vue-echarts";
use([CanvasRenderer, PieChart, TooltipComponent, TitleComponent]);

import {
  watch,
  reactive,
  onMounted,
  getCurrentInstance,
  onBeforeMount,
} from "@vue/composition-api";
import { formatter } from "@/utils/scripts/format-currency";
import { dynamicTableModel } from "@/models/data-management/dynamic-table";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";

export default {
  components: {
    VChart,
    CardNoItem,
  },
  props: {
    configCard: Object,
    dataBi: { type: Array, default: () => [] },
    keyid: Object,
    dynamicTableConfig: Object,
    BrandAppDetail: Object,
  },
  setup(props) {
    const vm = getCurrentInstance().proxy;

    const { openDefaultErrorModal } = useValidationModal();

    const { fetchQueryDataModel } = dynamicTableModel();

    const loading = reactive({
      Data: false,
    });

    const renderData = reactive({
      card_name: "",
      keyid: "",
      tooltip: "",
      fields: [],
      data: [],
      sumValue: [],
    });

    const option = reactive({
      // tooltip: {
      //   trigger: "item",
      //   formatter: "{a} <br/>{b} : {c} ({d}%)",
      //   textStyle: {
      //     fontFamily: "DBHelvethaicaX45Li",
      //     fontSize: 20,
      //   },
      // },
      textStyle: {
        fontFamily: "DBHelvethaicaX45Li",
        fontSize: 24,
      },
      title: {
        text: "",
        subtext: "",
        left: "center",
        top: "center",
        textStyle: {
          fontSize: 30,
        },
        subtextStyle: {
          fontSize: 20,
        },
      },
      series: [
        {
          name: "Summary",
          type: "pie",
          radius: ["30%", "60%"],
          avoidLabelOverlap: true,
          itemStyle: {
            borderRadius: 5,
            borderColor: "#fff",
            borderWidth: 5,
          },
          label: {
            show: false,
            position: "inner",
            formatter: "{d}%",
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 15, //text in pie chart
              fontWeight: "bold",
            },
          },
          labelLine: {
            show: false,
            length: 30,
          },
          data: [],
        },
      ],
    });

    const fetchSummaryDetail = () => {
      loading.Data = false;
      const payload = {
        Filters: [
          { Seq: 1, Key: "brandid", Value: props.BrandAppDetail.brandid },
        ],
        QueryData_Key: props.keyid.query_data_key,
        Query_Data_Key_Type: props.keyid.query_data_key_type,
        Display_Key: props.dynamicTableConfig.displayKey,
        Display_ChartId: props.keyid.display_chartid,
      };

      fetchQueryDataModel.payload = payload;
      console.log(fetchQueryDataModel);
      store
        .dispatch("api/apiRequest", fetchQueryDataModel)
        .then((response) => {
          const respData = response.data.payload.find(
            (o) => o.keyid == props.keyid.query_data_key
          );
          renderData.card_name = respData.card_name;
          renderData.keyid = respData.keyid;
          renderData.tooltip = respData.tooltip;
          renderData.fields = respData.fields;
          renderData.data = respData.data;
          renderData.sumValue = renderData.data.reduce(
            (acc, item) => acc + item.value,
            0
          );

          let renderDataChart = [];
          renderData.data.map((o) => {
            renderDataChart.push({
              value: o.value,
              name: o.title,
              itemStyle: { color: o.color },
            });
          });

          option.title.text = formatter.format(renderData.sumValue);
          option.title.subtext = renderData.data[0].unit;
          option.series[0].data = renderDataChart;
        })
        .catch((error) => {
          openDefaultErrorModal(error);
        })
        .finally(() => {
          loading.Data = false;
        });
    };

    onMounted(() => {
      fetchSummaryDetail();
    });

    watch(
      renderData,
      () => {
        // vm.$nextTick(() => {
        //   if (renderData.data.length > 0) {
        //     let renderDataChart = [];
        //     renderData.data.map((o) => {
        //       renderDataChart.push({
        //         value: o.value,
        //         name: o.title,
        //         itemStyle: { color: o.color },
        //       });
        //     });
        //     vm.$refs.chartBar?.setOption({
        //       series: [
        //         {
        //           data: renderDataChart,
        //         },
        //       ],
        //       title: {
        //         text: formatter.format(renderData.sumValue),
        //         subtext: renderData.data[0].unit,
        //       }
        //     });
        //     console.log("renderData")
        //   }
        // });
      },
      { deep: true }
    );

    return {
      loading,
      Tooltip,
      option,
      formatter,
      renderData,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/data-management/summary-dashboard.css";

.chart-customer {
  width: 100%;
  height: 310px;
}

.pie-chart-title {
  width: 100%;
  font-size: 22px;
}

.pie-chart-value {
  text-align: center;
  font-size: 38px;
  font-weight: bold;
  color: #000000 !important;
}

.justify-content-evenly {
  justify-content: space-evenly;
}

.pie-chart-radius-color {
  margin-right: 10px;
  border-radius: 4px;
  width: 25px;
  height: 20px;
}

.header-position {
  padding: 1.5rem !important;
}
</style>
